var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20PxHelp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0006 17.3599C14.0655 17.3599 17.3606 14.0648 17.3606 9.99989C17.3606 5.93508 14.0655 2.63989 10.0006 2.63989C5.93581 2.63989 2.64062 5.93508 2.64062 9.99989C2.64062 14.0648 5.93581 17.3599 10.0006 17.3599Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01758 8.01815C8.01758 7.62624 8.1339 7.24313 8.35184 6.91727C8.56976 6.59141 8.87952 6.33744 9.24193 6.18745C9.60434 6.03748 10.0031 5.99824 10.3878 6.0747C10.7726 6.15115 11.126 6.33987 11.4034 6.617C11.6807 6.89412 11.8696 7.2472 11.9462 7.63157C12.0227 8.01596 11.9834 8.41437 11.8333 8.77645C11.6832 9.13853 11.429 9.448 11.1028 9.66573C10.7766 9.88346 10.3932 9.99968 10.0009 9.99968V11.3207",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99987 13.916C9.84354 13.916 9.7168 13.7893 9.7168 13.6329C9.7168 13.4766 9.84354 13.3499 9.99987 13.3499",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.916C10.1563 13.916 10.2831 13.7893 10.2831 13.6329C10.2831 13.4766 10.1563 13.3499 10 13.3499",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxHelp);
export default __webpack_public_path__ + "static/media/icon_20px_help.f68a470a625c00269897446d43a56d79.svg";
export { ForwardRef as ReactComponent };